import cs from 'classnames';
import React from 'react';
import { Badge, OverlayTrigger, Popover } from 'react-bootstrap';
import classNames from './BadgeWithTooltip.module.scss';

interface BadgeWithTooltipProps {
    id: string,
    title: string,
    content: string | JSX.Element,
    showDelay?: number,
    hideDelay?: number,
    variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark',
    className?: string,
    placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto',
}

export function BadgeWithTooltip(props: BadgeWithTooltipProps) {
  const {
    id, title, content, showDelay, hideDelay,
    variant = 'secondary',
    className,
    placement = 'bottom',
  } = props;

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: showDelay ?? 250, hide: hideDelay ?? 400 }}
      overlay={(
        <Popover
          id={id}
          style={{ zIndex: 100000 }}
        >
          <Popover.Title as="h3">
            {title}
          </Popover.Title>
          <Popover.Content>
            <p>
              {content}
            </p>
          </Popover.Content>
        </Popover>
        )}
    >
      <div className={cs(classNames.badge, className)} data-testid="badgeContainer">
        <Badge
          pill
          variant={variant}
        >
          i
        </Badge>
      </div>
    </OverlayTrigger>
  );
}
